import type { Schemas } from '@npc/api-client'

import { api } from './api'
import { call } from './errors'

export type SpeechTranscription = Schemas['SpeechTranscription']

/** Upload one short recording for transcription. It does not send a message. */
export async function transcribeSpeech(input: {
  blob: Blob
  mimeType: string
  durationMS: number
}): Promise<SpeechTranscription> {
  const form = new FormData()
  form.append('audio', input.blob, input.mimeType.includes('mp4') ? 'speech.m4a' : 'speech.webm')
  form.append('duration_ms', String(input.durationMS))
  return call('/speech/transcriptions', () =>
    api.POST('/speech/transcriptions', {
      body: form as unknown as {
        audio: string
        duration_ms: number
      },
      bodySerializer: (body: unknown) => body as BodyInit,
    }),
  )
}
